import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {PageTitleStyled} from "./PageTitle.styled";
import {useMemo} from "react";

export function PageTitle({ text, className="title-wrapper", children, subtitle }) {
    const {t} = useTranslation();
    const titleData = useSelector(state => state.buildings.titleData); // loaded in the ManagerPage
    const titleDataLoaded = useMemo(() => titleData.translationKey != null && titleData.translationKey !== '', [titleData]);

    return (
        <PageTitleStyled className={className}>
            <h1>
                {text && <span>{text}</span>}
                {titleDataLoaded && <span className="building-address">{t(`payments.${titleData.translationKey}`, titleData)}</span>}
                {subtitle && <div className="subtitle">{subtitle}</div> }
            </h1>

            {children}
        </PageTitleStyled>
    );
}
